import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { routeParams } from '../../../../shared/shared.global-service';
import { SOCIAL_SERVICE_SETTINGS_PAYMENT_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';

@Injectable()
export class ServicesSettingsPageStore2 extends ComponentStoreV2Factory {

    public socialServicePaymentSetting = computed(() => this.globalGlobalStore.organizationStore.getServiceSetting(Number(routeParams.serviceId() || 0), SOCIAL_SERVICE_SETTINGS_PAYMENT_TYPE_KEY));

}
